import React from "react";
import { Megaphone, Users, Instagram, Target } from "lucide-react";
import { SectionHeader } from "./Rates";
import { BUSINESS } from "../mock";

const ICONS = { Megaphone, Users, Instagram, Target };

const scrollTo = (href) => {
  const el = document.querySelector(href);
  if (el) el.scrollIntoView({ behavior: "smooth" });
};

const Business = () => {
  return (
    <section id="promo" className="relative py-24 grid-bg">
      <div className="max-w-[1200px] mx-auto px-6 md:px-8">
        <SectionHeader eyebrow="Promote Your Business" title="Partner With TwinBrain!" sub="We are up for any type of promotional event. Leverage our growing community of 200+ members to grow your brand in Nagpur." />

        <div className="flex justify-center mb-12">
          <button onClick={() => scrollTo('#contact')} className="gold-btn font-ui text-xs tracking-[0.2em] uppercase px-8 py-4 font-medium transition-all hover:shadow-lg hover:shadow-gold/20">Get in Touch →</button>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6">
          {BUSINESS.map((b, i) => {
            const Icon = ICONS[b.icon];
            return (
              <div key={i} className="border border-white/8 bg-white/[0.02] p-8 card-glow text-center">
                <div className="h-14 w-14 rounded-full bg-gold/10 border border-gold/30 flex items-center justify-center text-gold mx-auto">
                  <Icon size={26} />
                </div>
                <h3 className="font-display text-xl text-white mt-5">{b.title}</h3>
                <p className="font-body text-gray-400 text-sm mt-2 leading-relaxed">{b.desc}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Business;
